<template>
    <div class="fixed-scroller">
        <div class="v-alert w-1200">
            <header><p>Staff - <span style="font-weight: bold;">{{ item.name }}</span></p><div class="x" @click="emit({ action: 'exit' })"></div></header>
            <div class="stats">
                <div class="totals">
                    <p>Totals</p>
                    <div><p class="sub-total">Loyalty</p></div>
                    <div v-for="reward in total.loyaltyAwards.sort((a,b) => a.start < b.start ? 1 : -1)" class="totals-loyalty">
                        <p class="td-ulb ellip" @click="showCustomer(reward.customer_id)">{{ getName(reward.customer_id) }}</p>
                        <p>{{ format(reward.start,'dd/MM/yy HH:mm') + ' - ' + format(reward.end,'dd/MM/yy HH:mm') }}</p>
                        <p class="ta-r mr-10">{{ reward.qty }}</p>
                    </div>
                    <div><p class="sub-total">Offers</p></div>
                    <div v-for="reward in total.redeemRewards.sort((a,b) => a.start < b.start ? 1 : -1)" class="totals-offers">
                        <p class="td-ulb ellip" @click="showCustomer(reward.customer_id)">{{ getName(reward.customer_id) }}</p>
                        <p>{{ format(reward.start,'dd/MM/yy HH:mm') + ' - ' + format(reward.end,'dd/MM/yy HH:mm') }}</p>
                        <p class="td-ulb ellip"  @click="showAd(reward.ad_id)">{{ getTitle(reward.ad_id) }}</p>
                        <p class="ta-r mr-10">{{ reward.qty }}</p>
                    </div>
                </div>
                <div class="loyalty">
                    <p>Loyalty Stamps</p>
                    <div v-for="reward in item.loyaltyAwards.sort((a,b) => a.now < b.now ? 1 : -1)" class="loyalty-item">
                        <p class="td-ulb ellip" @click="showCustomer(reward.customer_id)">{{ getName(reward.customer_id) }}</p>
                        <p>{{ reward.now > 0 ? format(reward.now,'dd/MM/yy HH:mm') : '' }}</p>
                        <p class="ta-r mr-10">{{ reward.qty  }}</p>
                    </div>
                </div>
                <div class="rewards">
                    <p>Offer Redemptions</p>
                    <div v-for="reward in item.redeemRewards.sort((a,b) => a.now < b.now ? 1 : -1)" class="rewards-items">
                        <p class="td-ulb ellip" @click="showCustomer(reward.customer_id)">{{ getName(reward.customer_id) }}</p>
                        <p class="td-ulb ellip" @click="showAd(reward.ad_id)">{{ getTitle(reward.ad_id) }}</p>
                        <p>{{ reward.now > 0 ? format(reward.now,'dd/MM/yy HH:mm') : '' }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="voucher" class="voucher fixed-scroller">
            <div class="v-alert">
                <header><p>{{ 'Offer' }}</p><div class="x" @click="voucher = false"></div></header>
                <Voucher :voucher="voucher" />
            </div>
        </div>
        <component v-if="component" :is="component" :item="customer"  style="z-index: 10;" @emit="emit" />
    </div>
</template>

<script>

import { format } from 'date-fns'
import Voucher from '../components/Voucher';
import WebSoc from '../utils/WebSoc.js';
import editMember from '../components/editMember.vue';

export default {
    name: 'stats-staff',
    props: ['item'],
    components: { Voucher, editMember },
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    data () {
        return {
            voucher: false,
            customer: false,
            component: '',
            format,
            customers: [],
            ads: [],
            total: {
                loyaltyAwards: [],
                redeemRewards: []
            }
        }
    },
    mounted () {
        var customer_ids = this.item.redeemRewards.map(r => r.customer_id).concat(this.item.loyaltyAwards.map(r => r.customer_id)).filter((customer_id,i,arr) => arr.indexOf(customer_id) == i).map(_id => { return { _id } })
        var ad_ids = this.item.redeemRewards.map(r => r.ad_id).concat(this.item.loyaltyAwards.filter(r => r.ad_id).map(r => r.ad_id)).filter((ad_id,i,arr) => arr.indexOf(ad_id) == i).map(_id => { return { _id } })
        var db = this.client_id+'-customers';
        
        this.total.loyaltyAwards = this.item.loyaltyAwards.reduce((p,reward) => {
            if ( !p[reward.customer_id] ) p.push(p[reward.customer_id] = { customer_id: reward.customer_id, start: reward.now, end: reward.now, qty: 0 });
            var current = p[reward.customer_id];
            current.start = Math.min(current.start,reward.now);
            current.end  = Math.min(current.end,reward.now);
            current.qty += reward.qty;
            return p;
        },[]);

        this.total.redeemRewards = this.item.redeemRewards.reduce((p,reward) => {
            var ref = reward.customer_id+':'+reward.ad_id;
            if ( !p[ref] ) p.push(p[ref] = { ad_id: reward.ad_id, customer_id: reward.customer_id, start: reward.now, end: reward.now, qty: 0 })
            var current = p[ref];
                current.start = Math.min(current.start,reward.now);
                current.end  = Math.min(current.end,reward.now); 
                current.qty += 1; 
                return p          
        },[])
        customer_ids.length > 0 && WebSoc.SEND('search',{ DB: db, find: { $or: customer_ids }, project: { name: 1 }},customers => {
            this.customers = customers;
        });
        ad_ids.length > 0 && WebSoc.SEND('search',{ DB: 'jb-ads', find: { $or: ad_ids }, project: { title: 1 } },ads => {
            this.ads = ads;
        })
    },
    methods: {
        showCustomer ( customer_id ) {
            WebSoc.SEND('get',{ DB: this.client_id+'-customers', _id: customer_id },customer => {
                this.customer = customer;
                this.component = 'editMember';
            })
        },
        showAd ( ad_id ) {
            WebSoc.SEND('search',{ DB: 'surveys', find: { 'pages.ad_id': ad_id }, limit: 1, project: { pages: 1 } },campaigns => {
                var ad = campaigns[0] && campaigns[0].pages.find(p => p.ad_id == ad_id);
                    ad.issued = 0;
                    ad.redeemed = 0;
                this.voucher = ad;
            })
        },
        getName ( customer_id ) {
            var customer = this.customers.find(c => c._id == customer_id);
            return customer ? customer.name : 'no name';
        },
        getTitle ( ad_id ) {
            var ad = this.ads.find(a => a._id == ad_id);
            return ad ? ad.title : 'no title';
        },
        'edit-member' ( action ) {
            switch ( action ) {
                case 'exit':
                    this.component = '';
                    this.customer = false;
                    return;
            }
            console.log('edit-member ?',action)
        },
        emit ( { t, action } ) {
            if ( this[t] ) return this[t]( action );
            this.$emit('emit',{ t: 'stats-staff', action, item: this.item });            
        }
    }
}

</script>

<style scopped lang="scss">
.stats {
    display: grid;;
    float: left;
    height: 100%;
    grid-template-columns: 1fr 270px 380px;
    > div {
        height: 100%;
        border-right: 1px solid #c0c0c0;
        &:last-child {
            border-right: 0px;
        }
    }
    > div > p {
        text-align: center;
        margin: 10px;
        font-weight: bold;
    }
    .loyalty-item {
        display: grid;
        grid-template-columns: 130px 1fr 20px;
        margin: 0px 3px;
        
    }
    .rewards-items {
        display: grid;
        grid-template-columns: 130px 1fr 120px;
        margin: 0px 3px;
    }
    .sub-total {
        margin:  4px;
        font-weight: bold;
    }
    .totals-loyalty {
        display: grid;
        grid-template-columns: 130px 1fr 40px;
        margin: 0px 3px;
    }
    .totals-offers {
        display: grid;
        grid-template-columns: 130px 240px 1fr 40px;
        margin: 0px 3px;
    }
}
</style>